import React, { useEffect, useState, useRef } from 'react';
import { FaInstagram, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './InstagramSection.css';
import InstagramData from '../../data/Instagram.json';

const InstagramSection = () => {
    const { t } = useTranslation();
    const [posts, setPosts] = useState([]);
    const scrollerRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    useEffect(() => {
        try {
            // JSON verisini yükle
            setPosts(InstagramData);
        } catch (error) {
            console.error('Error loading Instagram posts:', error);
        }
    }, []);

    const checkScrollability = () => {
        const el = scrollerRef.current;
        if (el) {
            const hasOverflow = el.scrollWidth > el.clientWidth;
            setCanScrollLeft(el.scrollLeft > 5);
            setCanScrollRight(hasOverflow && el.scrollLeft < el.scrollWidth - el.clientWidth - 5);
        }
    };

    useEffect(() => {
        const el = scrollerRef.current;
        if (el) {
            checkScrollability();
            el.addEventListener('scroll', checkScrollability);
            window.addEventListener('resize', checkScrollability);
        }
        return () => {
            if (el) {
                el.removeEventListener('scroll', checkScrollability);
                window.removeEventListener('resize', checkScrollability);
            }
        };
    }, [posts]);

    const scroll = (direction) => {
        const el = scrollerRef.current;
        if (el) {
            const scrollAmount = el.clientWidth;
            el.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    if (!posts || posts.length === 0) {
        return null;
    }

    return (
        <div className="instagram-section-container solid-mid-grey-bg">
            <button
                className="scroll-button prev"
                onClick={() => scroll('left')}
                disabled={!canScrollLeft}
                aria-label="Previous"
            >
                <FaChevronLeft />
            </button>
            
            <div className="instagram-scroller" ref={scrollerRef}>
                <div className="instagram-intro-card">
                    <p>
                        {t('home.instagram.description')}
                    </p>
                    <a href="https://www.instagram.com/hacettepefenfakultesi/" target="_blank" rel="noopener noreferrer" className="instagram-view-button">
                        {t('home.instagram.followButton')}
                    </a>
                </div>
                {posts.map(post => (
                    <a href={post.link} key={post.id} className="instagram-post-card" target="_blank" rel="noopener noreferrer">
                        <img src={post.imageUrl} alt="Instagram Post" />
                        <div className="instagram-overlay">
                            <p>{post.caption}</p>
                            <div className="instagram-icon">
                                <FaInstagram />
                            </div>
                        </div>
                    </a>
                ))}
            </div>
            
            <button
                className="scroll-button next"
                onClick={() => scroll('right')}
                disabled={!canScrollRight}
                aria-label="Next"
            >
                <FaChevronRight />
            </button>
        </div>
    );
};

export default InstagramSection; 